import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup} from "@angular/forms";
import {NgbActiveModal} from "@ng-bootstrap/ng-bootstrap";
import {CountriesInt} from "@interfaces/*";
import {TranslateService} from "@ngx-translate/core";
import {removeAccents} from "@app/utils";
import { AmKeyboardService } from '@app/shared/components/am-keyboard/am-keyboard.service';

/**
  Componente para mostrar un modal de selección con funcionalidad de búsqueda.
  Este componente permite buscar y seleccionar elementos de una lista, como países,
  y cerrar el modal con la opción seleccionada.
**/
@Component({
    selector: 'app-select-modal',
    templateUrl: './select-modal.component.html',
    styleUrls: ['./select-modal.component.scss'],
    standalone: false
})
export class SelectModalComponent implements OnInit {
 /**
    Formulario reactivo para gestionar la búsqueda.
  **/
    findForm: FormGroup = new FormGroup<any>({
      find: new FormControl('')
    });
  
    /**
      Lista completa de elementos disponibles para selección.
    **/
    list: Array<CountriesInt | any> = [];
  
    /**
      Lista de botones que se muestran en la interfaz, filtrados según la búsqueda.
    **/
    buttons: CountriesInt[] = [];
  
    /**
      Título del modal.
    **/
    title: string = '';
  
    /**
      Subtítulo del modal.
    **/
    subtitle: string = '';
  
    /**
      Nota o mensaje adicional que se muestra en el modal.
    **/
    notice: string = '';
  
    /**
      Elemento seleccionado por el usuario.
    **/
    selected: any;
  
    /**
      Idioma actual del sistema.
    **/
    currentLang: string;
  
    /**
      Identificador del contenido del teclado virtual.
    **/
    KeyboardContent = 'keyboard-content-select';
  
    /**
      Indica si el botón de continuar está deshabilitado.
    **/
    isDisabledButton: boolean = false;
  
    /**
      Indica si el teclado virtual está visible.
    **/
    public isShowKeyboard: boolean = false;

  constructor(
    public  modal: NgbActiveModal,
    localeServ: TranslateService,
    public keyboardService: AmKeyboardService,
  ) {
    this.currentLang = localeServ.currentLang.replace("-", "_");
  }

  ngOnInit(): void {
    this.findForm.valueChanges.subscribe({

      next: values => {
        const { find } = values;
        this.getListButtons(find);
      }
    });
    setTimeout(() => {
      this.getListButtons();
    }, 1000);

    this.keyboardService.getStatusKeyboard().subscribe({
      next: res => {
        if(res){
          this.isDisabledButton =  true;
        }else{
          this.isDisabledButton =  false;
        }
        this.isShowKeyboard = res
      }
    });
  }
  /**
    Limpia el campo de búsqueda y actualiza la lista de botones.
    @return void - No retorna ningún valor.
  **/
  clearField() {
    this.findForm.get('find').reset();
    this.getListButtons();
  }
  /**
    Maneja la selección de un elemento de la lista.
    @param opt Elemento seleccionado.
    @return void - No retorna ningún valor.
  **/
  onSelected(opt: CountriesInt | any) {
    this.findForm.get('find').setValue(opt[this.currentLang]);
    this.selected = opt;
  }

  onClose() {
    this.modal.dismiss();
  }

  onContinue() {
    this.modal.close(this.selected)
  }

  /**
    Filtra y actualiza la lista de botones según el término de búsqueda.
    @param search Término de búsqueda.
    @return void - No retorna ningún valor.
  **/
  getListButtons (search: string = "A"){
    const value = search && search.length > 1
    if(value) {
      search = removeAccents(search?.toLocaleUpperCase());
    }
    const important = this.list.filter(opt =>
      (opt.country === 'US' || opt.country === 'MX') );

    const filterData = this.list.filter((opt: CountriesInt) =>
      (removeAccents(opt[this.currentLang])?.toLocaleUpperCase()?.startsWith(search)
        || opt?.searchCriteria?.map(el => removeAccents(el)?.toLocaleUpperCase()).includes(search))
       );
    const data = filterData.slice(0, value ? 6: 4);

    this.buttons = value? data : important.concat(data);
  }

}
